import script from "./NewUserDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewUserDialog.vue?vue&type=script&setup=true&lang=ts"

import "./NewUserDialog.vue?vue&type=style&index=0&id=a50a2064&lang=scss"

const __exports__ = script;

export default __exports__